import {RouteEnum} from "@/router/RouteEnum.ts";
import CreateView from "@/views/CreateView.vue";

const create = {
  path: '/create/:target/:type',
  name: RouteEnum.Create,
  component: CreateView,
  props: true,
}

const accountRoutes = [create]
export default accountRoutes
